import { matchPath } from 'react-router';
import type { CurrentUserDto } from '../../../../../types/UserDtos';
import type { NavLink } from './links';

export const getLinkCurrent = (currentLocation: string) => (link: NavLink) => isMatching(currentLocation, link);

export const getLinkDisabled = (currentUser: CurrentUserDto) => (link: NavLink) =>
    link.isFeatureEnabled && !link.isFeatureEnabled(currentUser.company.enabledFeatures);

export const getLinkAvailable = (currentUser: CurrentUserDto) => (link: NavLink) => link.isAvailableTo(currentUser);

const isMatching = (currentLocation: string, link: NavLink) =>
    [link.route, ...(link.alsoMatch ?? [])].some(path => matchPath(currentLocation, { path }));
